"use client";

import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";
import type { ReactNode } from "react";

interface SessionProviderProps {
  children: ReactNode;
}

export function SessionProvider({ children }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      // Disable automatic session refetching
      // We use localStorage cache for optimistic loading instead
      refetchInterval={0} // Never refetch automatically
      refetchOnWindowFocus={false} // Don't refetch when window gains focus
    >
      {children}
    </NextAuthSessionProvider>
  );
}
